import cx from "classnames";
import NextPageIcon from "material-ui/svg-icons/navigation/chevron-right";
import PropTypes from "prop-types";
import {
  StyledHeaderOptimization,
  StyledRowOptimization,
  StyledValuesOptimization
} from './components'

import './expandable-table-optimization.css'
import Checkbox from 'components/checkbox'

const TableRow = ({
  childLevel,
  childrenKey,
  labelKey,
  code,
  item,
  labelsList,
  columnTemplate,
  children,
  expandedItems = [],
  resolveValue,
  resolveTitle,
  showCheckbox,
  onClick,
  onSelectItem,
  onExpandItem,
}) => {
  const isExpanded = expandedItems.includes(code)
  const hasChildren = !!children && children.length > 0

  return (
    <StyledRowOptimization isExpanded={isExpanded} hasChildren={hasChildren}>
      <StyledHeaderOptimization>
        <StyledValuesOptimization showCheckbox={showCheckbox()}>
          {hasChildren && (
            <button className="etb-btn" onClick={() => onExpandItem(code)}>
              <NextPageIcon />
            </button>
          )}
          {showCheckbox() && (
            <Checkbox
              name={`checkbox-${item.Id}`}
              className="align-check"
              checked={item.checked || false}
              onChange={(e) => {
                onSelectItem(!item.checked, item);
              }}
            />
          )}
        </StyledValuesOptimization>

        <div
          className={`etb-values ${hasChildren && childLevel === 1 ? "etb-bold" : ""}`}
          style={columnTemplate ? { display: "grid", gridTemplateColumns: columnTemplate } : undefined}
        >
          {labelsList.map((value) => {
            const displayValue = resolveValue ? resolveValue(value.key, item) : item[value.key];
            const displayValueAsString =
              typeof displayValue === "string" || typeof displayValue === "number"
                ? String(displayValue)
                : null;
            const tooltipValue = resolveTitle
              ? resolveTitle(value.key, item)
              : displayValueAsString;

            return (
              <div
                key={value.key}
                className="etb-column-optimization"
                style={value.customStyle}
                title={tooltipValue}
              >
                <span className="etb-text-content">{displayValue}</span>
              </div>
            );
          })}
        </div>
      </StyledHeaderOptimization>

      {hasChildren && (
        <div className={cx("etb-children", { expanded: isExpanded })}>
          {children.map((it, index) => (
            <TableRow
              key={`${code}-${it.Id}-${index}`}
              childLevel={childLevel + 1}
              code={`${code}-${it.Id}`}
              labelKey={labelKey}
              childrenKey={childrenKey}
              item={children[index]}
              label={it[labelKey]}
              labelsList={labelsList}
              columnTemplate={columnTemplate}
              expandedItems={expandedItems}
              resolveValue={resolveValue}
              resolveTitle={resolveTitle}
              showCheckbox={showCheckbox}
              onClick={onClick}
              onSelectItem={onSelectItem}
              onExpandItem={onExpandItem}
            >
              {it[childrenKey]}
            </TableRow>
          ))}
        </div>
      )}
    </StyledRowOptimization>
  );
};

TableRow.defaultProps = { childLevel: 1 }

TableRow.propTypes = {
  childLevel: PropTypes.number,
  labelKey: PropTypes.string,
  childrenKey: PropTypes.string,
  code: PropTypes.string,
  item: PropTypes.object,
  labelsList: PropTypes.array,
  columnTemplate: PropTypes.string,
  children: PropTypes.array,
  expandedItems: PropTypes.array,
  resolveValue: PropTypes.func,
  resolveTitle: PropTypes.func,
  showCheckbox: PropTypes.func,
  onClick: PropTypes.func,
  onSelectItem: PropTypes.func,
  onExpandItem: PropTypes.func,
}

export default TableRow
